<template>
  <div>
    <el-form :class="{ 'cs-form': isCs }" :model="form" :rules="rules" ref="form" label-position="top">
      <el-row :gutter="55">
        <template v-for="attr in attrs">
          <template v-if="getShow(attr, form)">
            <el-col :span="24" v-if="attr.type === 10 || attr.type === 11" :key="attr.attrCode">
              <el-button class="common-btn" style="margin: 15px 0 18px;" v-if="attr.type === 10 && !disabledAll" @click="addItem(attr)" :disabled="form[attr.attrCode] && form[attr.attrCode].length >= attr.fillLen">+ {{attr.attrName}}</el-button>
              <div class="form-row" v-for="(listItem, index) in form[attr.attrCode]" :key="attr.attrCode + index">
                <template v-for="showItem in attr.formConfig">
                  <div class="form-item" :style="`width: ${showItem.width || 100}px;`" :key="attr.attrCode + showItem.showKey" v-if="showItem.fillType !== 'button'">
                    <el-form-item :label="showItem.showValue" :rules="getTfsRules(showItem)" :prop="`${attr.attrCode}.${index}.${showItem.showKey}`" :class="{'is-required': showItem.isMust}">
                      <el-input v-model="listItem[showItem.showKey]" v-if="showItem.fillType === 'string'" :maxlength="showItem.fillLen" :disabled="disabledAll || (showItem.showAttr && showItem.showAttr.disabled)" @blur="showInputChange(showItem, form[attr.attrCode])"></el-input>
                      <el-input-number :disabled="disabledAll" v-if="showItem.fillType === 'number'" v-model="listItem[showItem.showKey]" controls-position="right" :min="showItem.min" :precision="showItem.precision" :max="showItem.max" :controls="false" :style="`width: ${showItem.width || 100}px;`"></el-input-number>
                      <el-select v-model="listItem[showItem.showKey]" placeholder="请选择" :disabled="disabledAll" style="width: 100%;" v-if="showItem.fillType === 'select'">
                        <el-option v-for="item in showItem.enumDetail" :key="item.enumCode" :label="item.enumName" :value="item.enumCode">
                        </el-option>
                      </el-select>
                      <el-date-picker v-model="listItem[showItem.showKey]" type="date" :placeholder="showItem.fillNotice" v-if="showItem.fillType === 'date'" value-format="yyyy-MM-dd" style="width: 100%;" :disabled="disabledAll"></el-date-picker>
                    </el-form-item>
                  </div>
                </template>
                <el-form-item label="" :prop="`${attr.attrCode}.${index}.${attr.childrenKey}`" :rules="attr.childrenArr ? getTfsRules(attr.childrenBtnObj) : []">
                  <div style="display: flex;position: relative;top: 2px;">
                    <el-button class="common-btn" style="margin-right: 5px;" @click="openAddDialog(attr, index)" v-if="attr.childrenArr && !disabledAll">+ {{attr.childrenBtnObj.showValue}}</el-button>
                    <el-button class="common-btn" style="margin-right: 5px;" v-if="attr.childrenArr && form[attr.attrCode][index][attr.childrenKey] && form[attr.attrCode][index][attr.childrenKey].length" @click="openAddDialog(attr, index)">{{attr.childrenBtnObj.childButtons}}</el-button>
                    <el-button v-if="!disabledAll && attr.type === 10 && form[attr.attrCode].length < attr.fillLen" class="copy-text-btn" type="text" @click="copyItem(attr, listItem, index)">复制</el-button>
                    <el-button v-if="!disabledAll && attr.type === 10 && form[attr.attrCode].length !== 1" class="cancel-text-btn" type="text" @click="delItem(attr, index)">删除</el-button>
                  </div>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="attr.rowNum ? 24/attr.rowNum : 8" v-else :key="attr.areaCode + attr.attrCode">
              <el-form-item :label="attr.attrName" :class="{'is-required': attr.isMust}" :rules="getTfsRules(attr)" :prop="attr.attrCode">
                <el-input v-model="form[attr.attrCode]" :maxlength="attr.fillLen" :disabled="disabledAll || (attr.showAttr && attr.showAttr.disabled)" v-if="attr.type === 0"></el-input>
                <el-date-picker v-model="form[attr.attrCode]" type="date" :placeholder="attr.fillNotice" v-if="attr.type === 1" value-format="yyyy-MM-dd" style="width: 100%;" :disabled="disabledAll"></el-date-picker>
                <el-select v-model="form[attr.attrCode]" placeholder="请选择" :disabled="disabledAll" style="width: 100%;" v-if="attr.type === 2" :multiple="!!(attr.showAttr && attr.showAttr.isMultiple)">
                  <el-option v-for="enumObj in attr.enums" :key="enumObj.enumCode" :label="enumObj.enumName" :value="enumObj.enumCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="attr.showAttr && attr.showAttr.wrap" :key="attr.areaCode + attr.attrCode + 1"></el-col>
          </template>
        </template>
      </el-row>
    </el-form>
    <el-dialog :title="currentAttr.childrenBtnObj && currentAttr.childrenBtnObj.showValue" :visible.sync="dialogVisible" width="1150px" :before-close="handleClose" class="transport-dialog" :append-to-body="true" :close-on-click-modal="false">
      <div class="add-title">{{currentAttr.childrenBtnObj && currentAttr.childrenBtnObj.formNotice}}</div>
      <el-button class="common-btn" style="margin-bottom: 23px;" @click="addChildrenItem" :disabled="dialogForm.currentList.length >= currentAttr.childrenBtnObj.fillLen" v-if="!disabledAll">+ {{currentAttr.childrenBtnObj && currentAttr.childrenBtnObj.showValue}}</el-button>
      <el-form :class="{ 'cs-form': isCs }" :model="dialogForm" :rules="rules" ref="dialogForm" label-position="top">
        <div class="form-row" v-for="(item, index) in dialogForm.currentList" :key="index">
          <template v-for="showItem in currentAttr.childrenArr">
            <div class="form-item" :style="`width: ${showItem.width || 130}px;`" :key="showItem.showKey + index">
              <el-form-item :label="showItem.showValue" :class="{'is-required': showItem.isMust}" :rules="getTfsRules(showItem, true)" :prop="`currentList.${index}.${showItem.showKey}`" :disabled="disabledAll">
                <el-input v-model="item[showItem.showKey]" v-if="showItem.fillType === 'string'" :disabled="disabledAll" :maxlength="showItem.fillLen"></el-input>
                <el-input-number :disabled="disabledAll" v-if="showItem.fillType === 'number'" v-model="item[showItem.showKey]" controls-position="right" :min="showItem.min" :precision="showItem.precision" :max="showItem.max" :controls="false" :style="`width: ${showItem.width || 130}px;`"></el-input-number>
                <el-select v-model="item[showItem.showKey]" placeholder="请选择" :disabled="disabledAll" style="width: 100%;" v-if="showItem.fillType === 'select'">
                  <el-option v-for="item in showItem.enumDetail" :key="item.enumCode" :label="item.enumName" :value="item.enumCode">
                  </el-option>
                </el-select>
                <el-date-picker v-model="item[showItem.showKey]" type="date" :placeholder="showItem.fillNotice" v-if="showItem.fillType === 'date'" value-format="yyyy-MM-dd" style="width: 100%;" :disabled="disabledAll"></el-date-picker>
              </el-form-item>
            </div>
          </template>
          <el-form-item label="" v-if="!disabledAll">
            <div style="display: flex;position: relative;top: 2px;">
              <el-button type="text" class="copy-text-btn" @click="copyChildrenItem(item, index)" v-if="dialogForm.currentList.length < currentAttr.childrenBtnObj.fillLen">复制</el-button>
              <el-button type="text" class="cancel-text-btn" @click="delChildrenItem(index)" v-if="dialogForm.currentList.length !== 1">删除</el-button>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!disabledAll">
        <el-button type="primary" @click="handleSubmit">保存</el-button>
        <el-button @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if="false" title="已添加货物" :visible.sync="addedDialogVisible" width="1000px" :before-close="handleClose" class="transport-dialog" :append-to-body="true">
      <div class="parent-info">
        <span class="label">货柜类型：</span>
        <span class="value">普柜 DC</span>
        <span class="label">货柜尺寸：</span>
        <span class="value">20尺</span>
        <span class="label">货柜编号：</span>
        <span class="value">ABC123</span>
        <span class="label">封条号：</span>
        <span class="value">1232323</span>
      </div>
      <div class="oiq-create-form">
        <div class="test-module">
          <el-table :data="[]" border :highlight-current-row="false" class="item-table">
            <el-table-column prop="" label="品名" align="center"></el-table-column>
            <el-table-column prop="" label="海关编码" align="center"></el-table-column>
            <el-table-column prop="" label="毛重(吨)" align="center"></el-table-column>
            <el-table-column prop="" label="货物体积（立方米）" align="center"></el-table-column>
            <el-table-column prop="" label="货物FOB价" align="center"></el-table-column>
            <el-table-column prop="" label="海运费" align="center"></el-table-column>
            <el-table-column prop="" label="危险品编码" align="center"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {applyMixins} from "src/components/application/components/mixin";
import { create, all } from 'mathjs'
const config = {
  number: 'BigNumber',
  precision: 64,
}
const math = create(all, config)
/**
 * type 0 填写 1 日期 2 下拉 3 checkbox 10 按钮 11 json表单
 * */
export default {
  name: "TFSBasicForm",
  mixins: [applyMixins],
  props: {
    attrs: {
      type: Array,
      default() {
        return []
      }
    },
    getList: {
      type: Boolean,
      default: true
    },
    currentData: {
      type: [Object, Array],
      default: null
    }
  },
  data() {
    return {
      form: {},
      formByCode: {},
      currentAttr: {
        childrenBtnObj: {}
      },
      dialogVisible: false,
      dialogForm: {
        currentList: [],
      },
      addedDialogVisible: false
    }
  },
  computed: {
    rules() {
      return {}
    }
  },
  watch: {
    attrs: {
      handler(val) {
        let form = {}
        val.forEach(item => {
          if (!this.disabledAll) item.defaultValue = item.showAttr && item.showAttr.defaultValue || ''
          form[item.attrCode] = item.defaultValue
          if (item.type === 3 || item.type === 10 || item.type === 11 || (item.type === 2 && item.showAttr && item.showAttr.isMultiple)) {
            form[item.attrCode] = item.defaultValue || []
          }
          if (item.type === 10 || item.type === 11) {
            item.formObj = {}
            item.formConfig.forEach(showItem => {
              if (!this.disabledAll) showItem.defaultValue = showItem.showAttr && showItem.showAttr.defaultValue || ''
              item.formObj[showItem.showKey] = showItem.defaultValue
              if (showItem.fillType === 'number') item.formObj[showItem.showKey] = undefined
              if (showItem.fillType === 'button') {
                item.childrenBtnObj = showItem
                item.childrenObj = {}
                item.childrenArr = showItem.form
                item.childrenKey = showItem.showKey
                item.formObj[showItem.showKey] = []
                showItem.form.forEach(formItem => {
                  if (!this.disabledAll) formItem.defaultValue = formItem.showAttr && formItem.showAttr.defaultValue || ''
                  item.childrenObj[formItem.showKey] = formItem.defaultValue
                  if (formItem.fillType === 'number') item.childrenObj[formItem.showKey] = undefined
                })
              }
            })
            this.addItem(item, 0, form)
          }
          this.formByCode[item.attrCode] = item
        })
        if (this.currentData && !this.isCountryChange) {
          if (this.getList) {
            this.currentData.forEach(v => {
              const attr = this.formByCode[v.attrCode] || {}
              const type = attr.type
              if (type === 3 || type === 10 || type === 11 || (type === 2 && attr.showAttr && attr.showAttr.isMultiple)) {
                form[v.attrCode] = v.attrText || []
                if (!form[v.attrCode].length && attr.defaultValue) form[v.attrCode] = attr.defaultValue
                return
              }
              form[v.attrCode] = v.attrValue
              if (!form[v.attrCode] && attr.defaultValue) form[v.attrCode] = attr.defaultValue
            })
          } else {
            form = Object.assign(form, this.currentData)
            Object.keys(form).forEach(key => {
              const attr = this.formByCode[key] || {}
              if (!form[key] && attr.defaultValue) form[key] = attr.defaultValue
            })
          }
        }
        this.form = form
      },
      immediate: true
    }
  },
  methods: {
    showInputChange(data, list) {
      if (data.showAttr && data.showAttr.isAdd) {
        this.form[data.showAttr.isAdd.attrCode] = math.format(list.reduce((prev,curr) => {
          const currValue = curr[data.showKey] || 0
          return math.chain(math.bignumber(currValue)).add(prev).done()
        }, math.bignumber(0)))
      }
    },
    handleClose() {
      this.dialogVisible = false
    },
    addItem(data, index, form) {
      if (form) {
        form[data.attrCode].push(JSON.parse(JSON.stringify(data.formObj)))
        return
      }
      this.form[data.attrCode].push(JSON.parse(JSON.stringify(data.formObj)))
    },
    copyItem(data, form, index) {
      this.form[data.attrCode].splice(index, 0, JSON.parse(JSON.stringify(form)))
      data.formConfig.forEach(item => this.showInputChange(item, this.form[data.attrCode]))
    },
    delItem(data, index) {
      this.form[data.attrCode].splice(index, 1)
      data.formConfig.forEach(item => this.showInputChange(item, this.form[data.attrCode]))
    },
    openAddDialog(data, index) {
      this.dialogVisible = true
      this.currentIndex = index
      this.currentAttr = JSON.parse(JSON.stringify(data))
      this.dialogForm.currentList = JSON.parse(JSON.stringify(this.form[this.currentAttr.attrCode][index][this.currentAttr.childrenKey]))
      if (!this.dialogForm.currentList.length) this.addChildrenItem()
    },
    copyChildrenItem(data, index) {
      this.dialogForm.currentList.splice(index, 0, JSON.parse(JSON.stringify(data)))
    },
    addChildrenItem() {
      const data = this.currentAttr
      this.dialogForm.currentList.push(JSON.parse(JSON.stringify(data.childrenObj)))
    },
    delChildrenItem(index) {
      this.dialogForm.currentList.splice(index, 1)
    },
    handleSubmit() {
      this.$refs.dialogForm.validate(validate => {
        if (validate) {
          this.form[this.currentAttr.attrCode][this.currentIndex][this.currentAttr.childrenKey] = JSON.parse(JSON.stringify(this.dialogForm.currentList))
          this.handleClose()
        } else {
          this.$message.error('请填写必填项')
        }
      })
    },
    getShow(attr, form) {
      let isShow = true
      if (attr.attrRules) {
        isShow = attr.attrRules.some(v => {
          return v.conditions.some(item => {
            return form[item.matchKey] && form[item.matchKey].includes(item.matchValue)
          })
        })
      }
      return isShow
    },
    getValidate() {
      const list = JSON.parse(JSON.stringify(this.attrs))
      if (this.getList) {
        list.forEach(item => {
          item.attrValue = ''
          if (item.type === 10 || item.type === 11 || item.type === 3 || (item.type === 2 && item.showAttr && item.showAttr.isMultiple)) {
            item.attrText = this.form[item.attrCode]
            return
          }
          item.attrValue = this.form[item.attrCode]
        })
      }
      return {
        list: this.getList ? list : JSON.parse(JSON.stringify(this.form)),
        validator: new Promise(resolve => this.$refs.form.validate(resolve))
      }
    },
  }
}
</script>

<style scoped lang="scss">
.add-title {
  color: rgb(51, 51, 51);
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 18px;

}
::v-deep .el-form-item__label {
  line-height: 18px;
}
.copy-text-btn {
  color: #CA4300;
}
.cancel-text-btn {
  color: #999999;
}
.form-row {
  display: flex;
  align-items: flex-end;
  ::v-deep .el-form-item__label {
    line-height: 18px;
  }
  .form-item {
    margin-right: 15px;
  }
}
.dialog-footer {
  text-align: center;
  .el-button {
    width: 100px;
  }
}
.parent-info {
  color: rgb(51, 51, 51);
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 16px;
  .value {
    font-weight: 700;
    margin: 0 15px 0 5px;
  }
}
</style>
<style lang="scss">
.transport-dialog {
  .common-btn {
    height: 36px;
    background: rgba(255, 102, 0, 0.05);
    border: 1px solid #CA4300;
    border-radius: 4px;
    font-size: 14px;
    color: #CA4300;
    line-height: 34px;
    padding: 0 17px;
    cursor: pointer;
    display: inline-block;
    &.is-disabled {
      color: #C0C4CC;
      cursor: not-allowed;
      background-image: none;
      background-color: #FFF;
      border-color: #EBEEF5;
    }
  }
}
</style>